






















































































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import LendingScheduleSettings from '@/models/Products/ProductSettings/DefaultSettings/Schedule/LendingScheduleSettings';
import LendingScheduleSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/Schedule/LendingScheduleSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'LendingScheduleSettingsRead', components: { ProductState, LendingScheduleSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: LendingScheduleSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

}
